<div class="wrapper">
  <app-milestone-banner [banner]="banner"></app-milestone-banner>

  <lib-breadcrumbs [delimiter]="'>'" class="ps-5"></lib-breadcrumbs>

  <div class="container">
    <ng-content></ng-content>
  </div>
</div>
